/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="类型">
        <el-select v-model="formInline.type" placeholder="请选择" size="medium">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="订单号：">
        <el-input size="small" v-model="formInline.orderNo" placeholder="请输入订单号"></el-input>
      </el-form-item>
       <el-form-item label="手机号：">
        <el-input size="small" v-model="formInline.mobile" maxlength="11" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="选泽日期：">
        <el-date-picker value-format='timestamp' v-model="formInline.value1" :default-time="['00:00:00', '23:59:59']"
          type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" @click="exportConsumptionOrder(formInline)">导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="orderNo" label="id" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="receiverName" label="买单用户" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="userId" label="用户id" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="receiverMobile" label="手机号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="receiverFullAddress" label="收货地址" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="orderOriginAmount" label="订单金额(含运费)" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="userOriginAmount" label="实付金额(含运费)" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="payTime" label="下单时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row.orderNo)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->

  </div>
</template>

<script>
  import {
    b2csupplierlist,b2cgoodssearch,
    b2corderlist
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        editForm: {
          id: '',
          name: '',
          payType: 1,
          partner: '',
          subMchId: '',
          appid: '',
          notifyUrl: '',
          signType: '',
          partnerKey: '',
          sellerUserId: '',
          certPath: '',
          certPassword: '',
          rsaKey: '',
          token: sessionStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          orderNo:"",
          mobile:"",
          payerUserid: '',
          mchName: '',
          orderId: '',
          value1: ['',''],
          type: 0
        },
        optionsorderState: '',
        // 删除部门
        seletedata: {
          ids: '',
          token: sessionStorage.getItem('logintoken')
        },
        options: [],
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      console.log(Date.parse(new Date()))
      this.formInline.value1[0] = Date.parse(new Date()) - 86400000;
      this.formInline.value1[1] = Date.parse(new Date());

    this.getdata(this.formInline)
    this.orderType()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    orderType() {
      let pro = {
        "userId": 'abcdef',
      }
      b2csupplierlist(pro)
        .then(res => {
          this.options = res.data
          console.log(this.options)
        })
    },
    // 获取公司列表
    getdata(parameter) {
      let pro = {
        "userId": 'abcdef',
        "current": parameter.page,
        "size": parameter.limit,
        supplierId: parameter.type,
        orderNo: parameter.orderNo,
        mobile: parameter.mobile,
        "beginDate": parameter.value1[0] / 1000,
        "endDate": parameter.value1[1] / 1000,
      }


      b2corderlist(pro)
        .then(res => {
          this.loading = false
          if (res.code == 200) {
            this.listData = res.data.records
            // 分页赋值
            this.pageparm.currentPage = res.data.current
            this.pageparm.pageSize = res.data.size
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    exportConsumptionOrder(parameter) {
      console.log('parameter',parameter)
      if (parameter.value1 == null) {
        parameter.value1 = []
      }
      let pro = {
        orderNo: parameter.orderNo,
        mobile: parameter.mobile,
        "beginDate": parameter.value1[0] / 1000,
        "endDate": parameter.value1[1] / 1000 + 86400,
      }
      b2cgoodssearch(pro)
      .then(res => {
        const link = document.createElement("a");
        try {
          //如果文件类型不确定的时候，可以不设置type
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel"
          });
          // let _fileName ='afsdf'
          let _fileName = res.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]; //文件名，中文无法解析的时候会显示 _(下划线),生产环境获取不到
          link.style.display = "none";
          // 兼容不同浏览器的URL对象
          const url = window.URL || window.webkitURL || window.moxURL;

          link.href = url.createObjectURL(blob);
          link.setAttribute(
            "download",
            _fileName.substring(_fileName.lastIndexOf("_"))
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          url.revokeObjectURL(link.href); //销毁url对象
        } catch (e) {
          let that = this
          if(res.data.type=='application/json'){
            const reader  = new FileReader();
              reader.readAsText(res.data, 'utf-8');
              reader.onload=function(){
              that.msg = JSON.parse(reader.result);
              //reader.result里面含报错信息
              }
            }
            setTimeout(()=>{
            this.$message({
              type: 'info',
              message: that.msg.msg
            })
          },100)
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.getdata(this.formInline)
    },
    handleEdit(index, id) {
      this.$router.push({
        name: 'b2cproduct1',
        query: {
          orderNo: id
        }
      })
    }
  }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/b2c/user.vue